module.exports = __webpack_public_path__ + "static/media/mobile-app.8bd9ee89.png";